import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import "./CancelOrderModal.scss";
import { useEffect } from "react";
import Button from "../../../../components/Button/Button";
import { useNavigate } from "react-router";

type Props = {
  isVisible: boolean;
  popupCloseHandler: () => void;
};

export default function CancelOrderModal({
  isVisible,
  popupCloseHandler,
}: Props) {
  const navigate = useNavigate();
  const handleClose = () => {
    popupCloseHandler();
  };

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isVisible]);

  const cancelBtnHandler = async () => {
    navigate("/order-pipeline/orders");
  };

  return (
    <>
      <MotifModal
        className={`CancelOrderModal ${name} `}
        onClose={handleClose}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="CancelOrderModalModelWrapper">
          <MotifModalHeader>
            Discard Order Extension?
          </MotifModalHeader>
          <MotifModalBody>
            <div className="discard_message">
              <p>{`If you leave now, your progress will be lost.`}</p>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={"Keep working"}
              variant={"primary"}
              className="cancel-btn"
              onClickHandler={handleClose}
            />
            <Button
              label={"Discard extension"}
              variant={"secondary"}
              className="save-btn "
              onClickHandler={cancelBtnHandler}
            />
          </MotifModalFooter>
        </div >
      </MotifModal >
    </>
  );
}
